import xhr from '../tools/xhr.js';
import auth from '../tools/storage.js';
import pointsMarkup from '../markup2/posters.js';
import toolsMarkup from '../markup/tools.js';
import cropWrap from '../tools/cropWrapper.js';

import tools from '../tools/tools.js';

const loaderSpinnerId = 'loader-enterprises';
const loaderSpinnerMessage = 'Загрузка';
const loaderSpinnerMarkup = toolsMarkup.getLoadSpinner(loaderSpinnerId, loaderSpinnerMessage);

const body = document.querySelector('#festSettings').querySelector('div[name=body]');

// const cropWrapNode1 = cardPosters.querySelector('#image-uploader-wrapper');
// const cardPhotoSpinner = cardPosters.querySelector('#uploadSpinner');

const menuBt =  document.querySelector('#MenuFestSettings');

let imageToUpload1 = null;
let servData = [];
let servDataDifferent = [];
let editNow = false;


const loadData = () => {
  // alert('fgd');
  // pointsMarkup.cleanContainer();
  // pointsMarkup.drawMarkupInContainer(loaderSpinnerMarkup);

  xhr.request = {
    metod: 'GET',
    url: 'festSettings',
    data: '',
    callbackSuccess: (answer) => {
      // console.log(answer);
      servData = [];
      if (answer.status === 200){
        servData = answer.data;
        // editNow = Boolean(servData.editNow);
        // alert(editNow)
      }
 
      tools.fillHTMLElementsWithData(body,'input', '', servData);
      tools.fillHTMLElementsWithData(body,'textarea', '', servData);
      tools.fillHTMLElementsWithData(body,'select', '', servData);

      body.querySelector('img').src = '';
      if(servData.img)
        body.querySelector('img').src = `https://festcontent.ru/fests/${auth.currentFestival}/poster.jpg`;


        body.querySelector('textarea[name=description]').style.height = body.querySelector('textarea[name=description]').scrollHeight+'px';

      // empty fields 
      // let allIputs = body.querySelectorAll('input');
      // // console.log(allIputs.length);?
      // if(allIputs)
      //   allIputs.forEach((item, index) => {
      //     item.value = '';
      //   })


      // заполнить все поля
    }
  };

  setElementsListeners();
};
function setElementsListeners () {
  let allInputs = body.querySelectorAll('input');
  if(allInputs)
    allInputs.forEach((item, index) => {
      if (editNow) {

        item.classList.remove('inputDisabled');
        item.removeEventListener('keyup',validChangedData);
        item.addEventListener('keyup',validChangedData);
      } else
        item.classList.add('inputDisabled');

    });

  let allTextArea = body.querySelectorAll('textarea');
  if(allTextArea)
    allTextArea.forEach((item, index) => {
      if (editNow) {
        item.classList.remove('inputDisabled');
        item.removeEventListener('keyup',validChangedData);
        item.addEventListener('keyup',validChangedData);
      } else
        item.classList.add('inputDisabled');

    });

  let allSelect = body.querySelectorAll('select');
  if(allSelect)
    allSelect.forEach((item, index) => {
      if (editNow) {
        item.classList.remove('inputDisabled');
        item.removeEventListener('change',validChangedData);
        item.addEventListener('change',validChangedData);
      } else
        item.classList.add('inputDisabled');

    });
}
function validChangedData (evt){
  if(evt.target){
    let elementHTML = evt.target;
    if (elementHTML.attributes.defaultvalue) {

      servDataDifferent = servDataDifferent.filter(function(item) {
          return item !== elementHTML.attributes.name.nodeValue
      });

      // servDataDifferent // удалить key
      if (elementHTML.attributes.defaultvalue.nodeValue === elementHTML.value)
        elementHTML.classList.remove('changedValue');
      else {
        servDataDifferent.push(elementHTML.attributes.name.nodeValue);
        elementHTML.classList.add('changedValue');
      }
      console.log(servDataDifferent);
    
    }
  }
  //defaultvalue

}

 body.querySelector('button[name=copyToClipboard]').addEventListener('click', function () {
  if (body.querySelector('input[name=requestHideKey]').value && body.querySelector('input[name=requestHideKey]').value.length > 6){

    navigator.clipboard.writeText('https://festcontent.ru/' + body.querySelector('input[name=requestHideKey]').value + '/sendFilmRequest');

    toolsMarkup.informationtModal = {
      'isMess' : true,
      'title': 'Ошибка',
      'message': 'Секрет-ссылка скопирована в буфер обмена.  ' + 'https://festcontent.ru/' + body.querySelector('input[name=requestHideKey]').value + '/sendFilmRequest'
    };
  } else 
    toolsMarkup.informationtModal = {
      'title': 'Ошибка',
      'message': 'Секрет-ссылка не скопирована в буфер обмена.'
    };


//  http://festcontent.ru/7gjfh5769gjvnеdgr336/


 });


const onSuccessCardLoad = (loadedPoints) => {
// document.querySelector(`#${loaderSpinnerId}`).remove();
  if (loadedPoints.status === 200) {
    // $(formAdd).modal('hide');

    // cardPhotoSpinner.innerHTML = loaderSpinnerMarkup;;
    // cardPhotoSpinner.style.opacity = 0;
    // cardPostersAddChange.innerHTML = 'Изменить';

    // if (loadedPoints.data.image && loadedPoints.data.image.length > 2) {
    //   let path = `${window.appSettings.xhrSettings.urlContentFest}${auth.currentFestival}/img/posters/${loadedPoints.data.image}.jpg`;
    //   // let path = `http://festappbuilder.ru/content/festival/${auth.data.currentFestival}/posters/${loadedPoints.data.image}.jpg`;
    //   // cardPostersPhoto.src = p
    //   cropWrap.setImg(cropWrapNode1, path);
    // }
    // cardPostersName.value = loadedPoints.data.creator;
    // cardPostersDesc.value = loadedPoints.data.desc;
    // // console.log(loadedPoints.data);

    // cardPosterssecondBlock.classList.remove('divDisabled');
    // $(cardPosters).modal('show');

  }
};
// cardPostersAddChange.addEventListener('click', function () {

//     xhr.request = {
//       metod: 'PUT',
//       url: `posters/${cardPosters.getAttribute('currentPoster')}`,
//       data: `creator=${cardPostersName.value}&desc=${cardPostersDesc.value}`,
//       callbackSuccess: onSuccessAddLoad
//     };
// });


export default {

  start() {
    // getPoints();
      menuBt.addEventListener('click', loadData);
  },

  redraw: loadData,

  stop() {
    pointsMarkup.cleanContainer();
    menuBt.removeEventListener('click', loadData);
  }
};
